'use strict';

module Patersons {
    export class ChangeRequest {
        id: number;
        accountId: string;
        changeRequestType: string;
        requestDate: Date;
        originalData: string;
        modifiedData: string;

        changeRequestTypeDescription: string;
        isApproved: boolean = false;
        isRejected: boolean = false;
        approvalStatusDescription: string;
    }
}